import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * This hook is used to get the members associated with a calculation.
 * @param calculationId - The ID of the calculation.
 * @returns The calculation members.
 */
export function useCalculationMembers(calculationId: string) {
	/** Hooks */
	const query = useQuery({
		queryKey: ["calculation-members", calculationId],
		queryFn: async () => {
			const response = await client.calculations[":calculationId"].members.$get({
				param: { calculationId },
			});
			const data = await responseHandler(response);
			return data;
		},
	});

	return {
		...query,
		members: query.data?.members,
	};
}
